var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headers"},[(!_vm.isMobile)?_c('PC',{attrs:{"category":_vm.category,"contact":_vm.contact}}):_vm._e(),(_vm.isMobile)?_c('Mobile',{attrs:{"category":_vm.category,"contact":_vm.contact,"onShow":_vm.onShow}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }